module.exports = __webpack_public_path__ + "static/add2ogo-ca7f922e791a986f9d21128bd3ba1436.png";